{
    "ReporttypeDesktopwallboard": "Desktop-wallboard (zonder licentie)",
    "ReporttypeDashboard": "Dashboard",
    "ReporttypeActivecalllist": "Actieve oproeplijst (zonder licentie)",
    "ReporttypeHistoriccalllist": "Historische oproeplijst",
    "ReporttypeUnreturnedlostcalls": "Niet-geretourneerde verloren oproepen (zonder licentie)",
    "ReporttypeExtensionlist": "Uitbreidingslijst (zonder licentie)",
    "ReporttypeAcdagentlist": "ACD-agentlijst (zonder licentie)",
    "ReporttypeHuntgrouplist": "Lijst met jachtgroepen (zonder vergunning)",
    "ReporttypeTrunkinterfacelist": "Lijst met trunkinterfaces",
    "ReporttypeCallsbytelno": "Oproepen per tel.nr",
    "ReporttypeCallsbyddi": "Oproepen via DDI (zonder licentie)",
    "ReporttypeCallsbyhalfhourinterval": "Oproepen met een interval van ½ uur",
    "ReporttypeCallsbyhalfhourplusday": "Oproepen per ½ uur + dag",
    "ReporttypeCallsbyday": "Oproepen overdag",
    "ReporttypeCallsbyweek": "Oproepen per week",
    "ReporttypeCallsbymonth": "Oproepen per maand",
    "ReporttypeCallsbyaccountcode": "Oproepen per accountcode (zonder licentie)",
    "ReporttypeAcddndactivitylog": "ACD \/ DND-activiteitenlogboek (zonder licentie)",
    "ReporttypeAcsnacodeusage": "ACS N.v.t. Codegebruik (zonder licentie)",
    "ReporttypeExternalcontent": "Inhoudsbeperking",
    "ReporttypeUnlicensedformattingstring": "|1 (zonder vergunning)",
    "GroupLive": "Live evenementen",
    "GroupEntity": "Entiteit",
    "GroupLogs": "Logboeken",
    "GroupInterval": "Interval",
    "GroupMisc": "Diverse filtering",
    "NAME": "ReportTypes"
}